import _ from 'lodash';
import { notifyAboutDoccumentIthenticateStatusUpdate } from 'rubriq/actions';
import * as c from './constants';
export var searchPlagiarism = function searchPlagiarism() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref) {
    var _getState$plagiarism;
    var application = _ref.application;
    var previousPlagiarisms = ((_getState$plagiarism = getState().plagiarism) === null || _getState$plagiarism === void 0 ? void 0 : _getState$plagiarism.plagiarisms) || [];
    dispatch({
      type: c.PLAGIARISM_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/ithenticate/search', data)).then(function (json) {
      var plagiarisms = json;
      plagiarisms.forEach(function (newDoc) {
        var oldDoc = previousPlagiarisms.find(function (doc) {
          return doc.fileIdentity === newDoc.fileIdentity;
        });
        if (oldDoc && oldDoc.status !== newDoc.status) {
          if (newDoc.status === c.STATUS_GENERATED) {
            dispatch(notifyAboutDoccumentIthenticateStatusUpdate('report_ready', true));
            dispatch({
              type: c.SET_DOCUMENT_PROCESSING,
              fileIdentity: newDoc.fileIdentity,
              isProcessing: false
            });
          } else if (newDoc.status === c.STATUS_FAILED) {
            dispatch(notifyAboutDoccumentIthenticateStatusUpdate(newDoc.error_message || 'report_processing_failed', false));
            dispatch({
              type: c.SET_DOCUMENT_PROCESSING,
              fileIdentity: newDoc.fileIdentity,
              isProcessing: false
            });
          }
        }
      });
      dispatch({
        type: c.PLAGIARISM_SEARCH_COMPLETED,
        plagiarisms: plagiarisms
      });
      return plagiarisms;
    });
  };
};
export var createPlagiarism = function createPlagiarism(plagiarismUpdateRequest) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    return dispatch(application.post('/api/ithenticate/create', plagiarismUpdateRequest)).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: error.error,
            params: JSON.parse(error.getJsonEncodedParams() || '{}')
          }));
        }
      } else if (searchOnSuccess) {
        dispatch(searchPlagiarism());
      }
      return json;
    });
  };
};
export var generateReport = function generateReport(fileIdentity) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    dispatch({
      type: c.SET_DOCUMENT_PROCESSING,
      fileIdentity: fileIdentity,
      isProcessing: true
    });
    if (searchOnSuccess) {
      dispatch(searchPlagiarism());
    }
    return dispatch(application.postWithoutPopup("/api/ithenticate/submit-to-tca/".concat(fileIdentity))).then(function (json) {
      if (json.status === 'error') {
        if (showError) {
          dispatch(notifyAboutDoccumentIthenticateStatusUpdate(json.error_text || json.message || 'report_processing_failed', false));
        }
      }
      return json;
    }).catch(function () {
      if (showError) {
        dispatch(searchPlagiarismWithErrorLog());
      }
    });
  };
};
export var searchPlagiarismWithErrorLog = function searchPlagiarismWithErrorLog() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    dispatch({
      type: c.PLAGIARISM_SEARCH_REQUESTED
    });
    var getErrorMessage = function getErrorMessage(error) {
      return c.PLAGIARISM_ERROR_MAP[error] || c.DEFAULT_PLAGIARISM_ERROR;
    };
    var processDocuments = function processDocuments(documents) {
      if (Array.isArray(documents)) {
        documents.forEach(function (document) {
          if (document.status === 'Error' && document.errorLog) {
            dispatch(notifyAboutDoccumentIthenticateStatusUpdate(getErrorMessage(document.errorLog), false));
          }
        });
      }
      return documents;
    };
    return dispatch(application.get('/api/ithenticate/search', data)).then(function (json) {
      var plagiarisms = processDocuments(json);
      dispatch({
        type: c.PLAGIARISM_SEARCH_COMPLETED,
        plagiarisms: plagiarisms
      });
      return plagiarisms;
    }).catch(function (error) {
      dispatch({
        type: c.PLAGIARISM_SEARCH_FAILED,
        error: error.message || 'API request failed'
      });
      if (error.response && error.response.data && Array.isArray(error.response.data)) {
        processDocuments(error.response.data);
      } else {
        dispatch(notifyAboutDoccumentIthenticateStatusUpdate('report_processing_failed', false));
      }
      throw error;
    });
  };
};
export var viewFullReport = function viewFullReport(fileIdentity) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    return dispatch(application.post("/api/ithenticate/tca-report-viewer-url/".concat(fileIdentity))).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(notifyAboutDoccumentIthenticateStatusUpdate('plagiarism-view-full-report-error-msg', false));
        }
      } else if (searchOnSuccess) {
        dispatch(notifyAboutDoccumentIthenticateStatusUpdate('report_ready', true));
        dispatch(searchPlagiarism());
      }
      return json;
    });
  };
};